/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AirlineResponse
 */
export interface AirlineResponse {
    /**
     * 
     * @type {string}
     * @memberof AirlineResponse
     */
    airlineId?: string;
    /**
     * 
     * @type {string}
     * @memberof AirlineResponse
     */
    iataCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AirlineResponse
     */
    icaoCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AirlineResponse
     */
    fullName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AirlineResponse
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AirlineResponse
     */
    smallLogo?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AirlineResponse
     */
    largeLogo?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AirlineResponse
     */
    deleted?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AirlineResponse
     */
    effective?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AirlineResponse
     */
    enabled?: boolean;
}

export function AirlineResponseFromJSON(json: any): AirlineResponse {
    return AirlineResponseFromJSONTyped(json, false);
}

export function AirlineResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AirlineResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'airlineId': !exists(json, 'airlineId') ? undefined : json['airlineId'],
        'iataCode': !exists(json, 'iataCode') ? undefined : json['iataCode'],
        'icaoCode': !exists(json, 'icaoCode') ? undefined : json['icaoCode'],
        'fullName': !exists(json, 'fullName') ? undefined : json['fullName'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'smallLogo': !exists(json, 'smallLogo') ? undefined : json['smallLogo'],
        'largeLogo': !exists(json, 'largeLogo') ? undefined : json['largeLogo'],
        'deleted': !exists(json, 'deleted') ? undefined : json['deleted'],
        'effective': !exists(json, 'effective') ? undefined : json['effective'],
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
    };
}

export function AirlineResponseToJSON(value?: AirlineResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'airlineId': value.airlineId,
        'iataCode': value.iataCode,
        'icaoCode': value.icaoCode,
        'fullName': value.fullName,
        'name': value.name,
        'smallLogo': value.smallLogo,
        'largeLogo': value.largeLogo,
        'deleted': value.deleted,
        'effective': value.effective,
        'enabled': value.enabled,
    };
}


